import type { GtmCommonData, GtmCommonDataResponse } from '@/interfaces/IGtm'
import useAxios from '@/composable/useAxios'

export const getGtmCommonData = async (): Promise<GtmCommonData> => {
    const {
        data: { data },
    } = await useAxios.get<GtmCommonDataResponse>('/customer-gtm-info')
    return data
}
